export default "__VITE_ASSET__BTGj9UET__"